import { Component, OnInit } from '@angular/core'
import { AuthService } from './services'
import { AnalyticsService } from './analytics'

@Component( {
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

  constructor (
    private auth: AuthService,
    private analytics: AnalyticsService
  ) {}

  public ngOnInit () {
    // a page load that restores a session never goes through the login flow,
    // so the analytics identity is re-established here
    if (this.auth.isLoggedIn()) {
      this.analytics.identifyUser(this.auth.getCurrentUser())
    }
  }
}
